/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Auth_LoginInputs */

const nl_app_auth_login = /** @type {(inputs: App_Auth_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen`)
};

/**

* @param {App_Auth_LoginInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const app_auth_login = /** @type {((inputs?: App_Auth_LoginInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Auth_LoginInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_app_auth_login(inputs)
});
export { app_auth_login as "app.auth.login" }